import React from 'react';
import { withRouter } from 'react-router-dom';
import PropTypes from 'prop-types';
import './styles.scss';

const ButtonToNavigate = ({ history, path, buttonText, ...restProps }) => (
    <button
        className="btn btn-navigation"
        type="button"
        onClick={() =>
            history.push({ pathname: path, state: { ...restProps } })
        }
    >
        {buttonText}
    </button>
);

ButtonToNavigate.propTypes = {
    history: PropTypes.shape({
        push: PropTypes.func.isRequired,
    }),
    path: PropTypes.string,
    buttonText: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
};

export default withRouter(ButtonToNavigate);
